import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpClient } from '@angular/common/http';
import { catchError, map, switchMap, withLatestFrom, tap, mapTo } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { BackendAccountService } from '../../services/backend-account.service';
import { getCustomerConfigInfo } from '../../reducers';
import { ProfileActionTypes } from '../../actions/account/actions-profile';
import * as ProfileAction from '../../actions/account/actions-profile';
import { HeaderAlertService, InitCustomerConfig } from '@uxdf/direct-shared-lib';

@Injectable()
export class EffectsProfile {
  getProfile$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProfileActionTypes.GetProfile),
      switchMap(() =>
        this.backendAccountService.getProfile().pipe(map(data => new ProfileAction.GetProfileSuccess(data)))
      )
    )
  });

  updateProfile$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProfileActionTypes.UpdateProfileInit),
      map(action => action['payload']),
      withLatestFrom(this.store.pipe(select(getCustomerConfigInfo))),
      switchMap(([profile, customerConfigState]) =>
        this.backendAccountService
          .updateProfile(profile, customerConfigState.customerConfig.default_store_code)
          .pipe(mapTo(new ProfileAction.UpdateProfileSuccess(true)))
      ),
      catchError(error => {
        if (error.status === 409) {
          return of(new ProfileAction.UpdateProfileErrorVersionConflict());
        }
      })
    )
  });

  updateProfileSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProfileActionTypes.UpdateProfileSuccess),
      switchMap(() => {
        this.alert.clean();
        this.alert.add({
          type: 'success',
          content: $localize`:@@effects-profile.profileAccountWasUpdated:Your profile was updated`
        });

        return [new ProfileAction.GetProfile(), new InitCustomerConfig()];
      })
    )
  });

  updateProfileErrorVersionConflict$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProfileActionTypes.UpdateProfileErrorVersionConflict),
      mapTo(new ProfileAction.GetProfile())
    )
  });

  constructor(
    private readonly actions$: Actions,
    private readonly http: HttpClient,
    private readonly store: Store<any>,
    private readonly backendAccountService: BackendAccountService,
    private readonly alert: HeaderAlertService
  ) { }
}
